import { Button } from "@mui/material";
import { useEffect, useState } from "react";
import {
  Show,
  Tab,
  TabbedShowLayoutTabs,
  useRefresh,
} from "react-admin";
import { useLocation, useNavigate } from "react-router-dom";
import HouseService from "../../services/HouseService";
import UpdateHouseSlcDialog from "../Common/UpdateHouseSlcDialog";
import HouseChefForPartyTab from "./HouseChefForPartyTab";
import HouseMetaShow from "./HouseMetaShow";
import HouseOmsTableTab from "./HouseOmsTableTab";
import PermanentReplacementTab from "./HousePRTab";
import HousesRefundsTab from "./HouseRefundsTab";
import HousesCouponTab from "./HousesCouponTab";
import HousesCustomersTab from "./HousesCustomersTab";
import HouseStarCleanerVisitsTab from "./HousesStarCleanerVisitsTab";
import HousesStarChefVisitsTab from "./HouseStarChefVisitsTab";
import HousesTransactionTab from "./HousesTransactionTab";
import HousesUserBundleTab from "./HousesUserBundleTab";
import HouseTrialTab from "./HouseTrialsTab";
import Op from "../../interfaces/SequalizeFilters/SequalizeTypes";
import CookServeList from "../Common/CookServeList";
import CookAdditionalDetails from "../Cooks/CookAdditionalDetails";
import {
  ButtonContainer,
  SectionTitleRow,
  ShowScrollHoldContainer,
  ShowTabsContainer,
  WorkspaceContainer,
  WorkspaceHeader,
  WorkspaceIconBadge,
  WorkspacePanel,
  WorkspaceSubtitle,
  WorkspaceTitle,
} from "../../styles/commonStyles";

import { HouseIcon } from "../Svg";

const houseService = new HouseService();

const HouseTabShow = () => {
  let location = useLocation();
  let houseId = location.pathname.split("/")[2];
  let id = parseInt(houseId);

  let [subData, setSubData] = useState<any>(null);

  console.log("Sub data :", subData);

  const refreshData = (houseId: number) => {
    houseService
      .getAllCustomerForHouse(houseId)
      .then((data) => {
        setSubData(data);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  useEffect(() => {
    refreshData(id);
  }, [id]);
  return (
    <ShowTabsContainer
      tabs={
        <TabbedShowLayoutTabs
          variant="scrollable"
          scrollButtons="auto"
          selectionFollowsFocus={true}
        />
      }
      
    >
      <Tab label={"Details"}>
        <WorkspacePanel>
          <HouseMetaShow />
        </WorkspacePanel>
      </Tab>
      <Tab label={"Chef For Party"}>
        <HouseChefForPartyTab houseId={parseInt(houseId)} />
      </Tab>
      <Tab label={"CHEFIT"}>
        <HouseOmsTableTab
          houseId={parseInt(houseId)}
          filter={{ userLeaveMarkedId: { [Op.eq.toString()]: null } }}
        />
      </Tab>
      <Tab label={"All Customer"}>
        <HousesCustomersTab houseId={parseInt(houseId)} />
      </Tab>
      <Tab label={"Customer Extra Details"}>
        <CookAdditionalDetails
          partyId={subData?.data[0]?.id}
          referenceModel="CUSTOMER_MODEL"
        />
      </Tab>
      <Tab label={"Cook Serve List"}>
        <CookServeList hasService={false} houseId={parseInt(houseId)} />
      </Tab>
      <Tab label={"Transaction"}>
        <HousesTransactionTab houseId={parseInt(houseId)} />
      </Tab>
      <Tab label={"Refunds"}>
        <HousesRefundsTab houseId={parseInt(houseId)} />
      </Tab>
      <Tab label={"Coupons"}>
        <HousesCouponTab houseId={parseInt(houseId)} />
      </Tab>
      <Tab label={"OMS TR"}>
        <HouseOmsTableTab
          houseId={parseInt(houseId)}
          filter={{ userLeaveMarkedId: { [Op.not.toString()]: null } }}
        />
      </Tab>
            <Tab label={"Star Chef Visits"}>
        <HousesStarChefVisitsTab houseId={parseInt(houseId)} />
      </Tab>
      <Tab label={"Star Cleaner Visits"}>
        <HouseStarCleanerVisitsTab houseId={parseInt(houseId)} />
      </Tab>
      <Tab label={"Bundle Mapping Details"}>
        <HousesUserBundleTab houseId={parseInt(houseId)} />
      </Tab>
      <Tab label={"Trials Details"}>
        <HouseTrialTab houseId={parseInt(houseId)} />
      </Tab>
      <Tab label={"Permanent Replacement"}>
        <PermanentReplacementTab houseId={parseInt(houseId)} />
      </Tab>
    </ShowTabsContainer>
  );
};

const HouseShow = (props: any) => {
  const [openUpdateSlcDialog, setOpenUpdateSlcDialog] = useState(false);

  let location = useLocation();
  let houseId = location.pathname.split("/")[2];

  const refresh = useRefresh();

  let navigate = useNavigate();
  const navigateToTrialsCreate = () => {
    let path = `/Trials/create`;
    navigate(path);
  };

  const ShowAction = () => {
    return (
      <>
        <WorkspaceHeader>
          <SectionTitleRow>
            <WorkspaceIconBadge>
              <HouseIcon />
            </WorkspaceIconBadge>
            <div>
              <WorkspaceTitle>House Details</WorkspaceTitle>
              <WorkspaceSubtitle>
                View and manage house information
              </WorkspaceSubtitle>
            </div>
          </SectionTitleRow>
          <ButtonContainer>
            <Button
              variant={"contained"}
              onClick={navigateToTrialsCreate}
              style={{
                margin: "8px 8px 0px 0px",
                backgroundColor: "rgba(25, 117, 210, 0.9)",
                color: "#fff",
              }}
              size="small"
            >
              Create Trial
            </Button>

            <Button
              variant="contained"
              size="small"
              style={{
                margin: "8px 8px 0px 0px",
                backgroundColor: "rgba(25, 117, 210, 0.9)",
                color: "#fff",
              }}
              onClick={() => setOpenUpdateSlcDialog(!openUpdateSlcDialog)}
            >
              Update SLC
            </Button>
          </ButtonContainer>
        </WorkspaceHeader>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginBottom: "20px",
          }}
        ></div>
      </>
    );
  };

  return (
    <WorkspaceContainer>
      <div>
        <UpdateHouseSlcDialog
          open={openUpdateSlcDialog}
          setOpen={setOpenUpdateSlcDialog}
          callback={async (localityId) => {
            await houseService.updateSlc(Number(houseId), localityId);
            refresh();
          }}
        />
        <Show
          {...props}
          actions={<ShowAction />}
          title=" "
          sx={{
            "& .RaShow-card": {
              boxShadow: "none",
              border: "none",
            },
          }}
        >
          <ShowScrollHoldContainer>
            <HouseTabShow />
          </ShowScrollHoldContainer>
        </Show>
      </div>
    </WorkspaceContainer>
  );
};
export default HouseShow;
